import { css } from '@emotion/react';
import { color, spacing, shadow, typography } from '@uniquegood/realworld-studio-design';

import { TOP_BAR_HEIGHT } from '@/components/TopBar/Topbar';
import { onMobile } from '@/styles/responsive';
import { SIDE_PANEL_WIDTH } from './constants';

export const FlowContainerStyle = css`
  position: relative;
  width: 100%;
  height: calc(100vh - ${TOP_BAR_HEIGHT});
  overflow: hidden;

  .react-flow__attribution {
    display: none;
  }
`;

export const ToolbarStyle = css`
  position: absolute;
  top: ${spacing.common.medium};
  left: ${spacing.common.medium};
  z-index: 5;
  display: flex;
  align-items: center;
  gap: ${spacing.common.small};
  background-color: ${color.surface_default_default};
  padding: ${spacing.common.small} ${spacing.common.medium};
  border-radius: ${spacing.borderRadius.medium};
  ${shadow.card};
`;

export const ModeToggleStyle = css`
  position: absolute;
  top: ${spacing.common.medium};
  right: ${spacing.common.medium};
  z-index: 5;
`;

export const SidePanelContainerStyle = css`
  position: absolute;
  top: 0;
  right: 0;
  width: ${SIDE_PANEL_WIDTH}px;
  height: 100%;
  background-color: ${color.surface_default_default};
  border-left: 1px solid ${color.border_default_subdued};
  ${shadow.popup};
  z-index: 10;
  display: flex;
  flex-direction: column;

  ${onMobile} {
    width: 100%;
  }
`;

export const SidePanelHeaderStyle = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${spacing.common.medium} ${spacing.common.large};
  border-bottom: 1px solid ${color.border_default_subdued};
  flex-shrink: 0;
`;

export const SidePanelBodyStyle = css`
  flex: 1;
  overflow-y: auto;
  padding: ${spacing.common.large};
`;

export const SidePanelCloseButton = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  border-radius: ${spacing.borderRadius.small};
  cursor: pointer;
  color: ${color.text_subdued};

  &:hover {
    background-color: ${color.surface_default_hovered};
  }
`;

export const SidePanelFooterStyle = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${spacing.common.medium} ${spacing.common.large};
  border-top: 1px solid ${color.border_default_subdued};
  flex-shrink: 0;
`;

export const ContextMenuStyle = css`
  position: fixed;
  z-index: 20;
  min-width: 160px;
  background-color: ${color.surface_default_default};
  border: 1px solid ${color.border_default_subdued};
  border-radius: ${spacing.borderRadius.medium};
  ${shadow.popup};
  padding: 4px 0;
  overflow: hidden;
`;

export const ContextMenuItemStyle = css`
  display: flex;
  align-items: center;
  gap: ${spacing.common.small};
  width: 100%;
  padding: 8px ${spacing.common.medium};
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: ${typography.size.s2};
  color: ${color.text_default};
  text-align: left;

  &:hover {
    background-color: ${color.surface_default_hovered};
  }
`;

export const ContextMenuItemDestructive = css`
  color: ${color.text_critical};

  &:hover {
    background-color: ${color.surface_critical_subdued};
  }
`;
